// @see https://stackoverflow.com/a/2091331
var getQueryVariable = function(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for(var i = 0; i < vars.length; i++){
        var pair = vars[i].split("=");
        if (decodeURIComponent(pair[0]) === variable) return decodeURIComponent(pair[1]);
    }
    return false;
};
// @see https://stackoverflow.com/a/10997390
var updateURLParameter = function(url, param, paramVal) {
    var TheAnchor;
    var newAdditionalURL = "";
    var tempArray = url.split("?");
    var baseURL = tempArray[0];
    var additionalURL = tempArray[1];
    var temp = "";
    if (additionalURL) {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
        if (TheAnchor) additionalURL = TheParams;
        tempArray = additionalURL.split("&");
        for(var i = 0; i < tempArray.length; i++)if (tempArray[i].split("=")[0] !== param) {
            newAdditionalURL += temp + tempArray[i];
            temp = "&";
        }
    } else {
        var tmpAnchor1 = baseURL.split("#");
        var TheParams1 = tmpAnchor1[0];
        TheAnchor = tmpAnchor1[1];
        if (TheParams1) baseURL = TheParams1;
    }
    if (TheAnchor) paramVal += "#" + TheAnchor;
    var rows_txt = temp + "" + param + "=" + paramVal;
    return baseURL + "?" + newAdditionalURL + rows_txt;
};
var setSkin = function(el) {
    var header = document.querySelector(".navbar");
    var t = getQueryVariable("t");
    if (t) {
        for(var skin in skins)if (skins[skin] === t) {
            document.body.classList.remove("bg-" + t);
            header.classList.remove("bg-" + t, "navbar-" + t);
        } else {
            t = skins[skin];
            document.body.classList.add("bg-" + t);
            header.classList.add("bg-" + t, "navbar-" + t);
            break;
        }
    } else {
        t = "light";
        document.body.classList.remove("bg-dark");
        header.classList.remove("bg-dark", "navbar-dark");
        document.body.classList.add("bg-light");
        header.classList.add("bg-light", "navbar-light");
    }
    darkmode.inDarkMode = t === "dark";
    el.href = updateURLParameter(window.location.href, "t", t);
    document.querySelector(".logo").textContent = t === "dark" ? "nights_stay" : "wb_sunny";
};
var skins = [
    "dark",
    "light"
];
var el = document.querySelector(".invert_color");
el.addEventListener("click", function(ev) {
    return setSkin(ev.target);
});
setSkin(el);

//# sourceMappingURL=form.90e6c05d.js.map
